import ChessLinkContainer from './ChessLinkContainer';
export default ChessLinkContainer;



// WEBPACK FOOTER //
// ./src/components/Building/Main/ChessLinkContainer/index.js